<template>
	<div class="el-row leader main-content">
		<!-- 上 -->
		<el-row :gutter="10" class="top_matter">
			<el-col :span="18" :xl="18" :lg="17">
				<el-card class="statistics_matter common_matter">
					<div class="title">
						<p>交易统计</p>
						<!-- <div class="time_click">
							<span :class="item.active==timeActive?'active':null" v-for="(item,i) in timeList" :key="i" @click="timeClick(item.active)">{{item.name}}</span>
						</div> -->
					</div>
					<div class="statistics_con">
						<div class="statistics_left">
							<div class="time_click">
								<span :class="item.active == timeActive ? 'active' : null" v-for="(item, i) in timeList" :key="i"
									@click="timeClick(item.active)">{{ item.name }}</span>
							</div>
							<div class="card">
								<div class="img">
									<img src="../../../assets/images/home/leader-index-top.png" alt="">
								</div>
								<div>
									<p class="card_top_p">
										{{ timeActive | timeActiveFilter }}累计成交额({{ cumData.transactionAmountDigit == 1 ? '亿元' : '万元' }})
									</p>
									<p :title="'¥' + cumData.transactionAmount">¥{{ cumData.transactionAmount }}</p>
								</div>
							</div>
							<div class="card_msg" v-show="timer1Change" @mouseover="mouseOver(1)"
								@mouseleave="mouseLeave(1)">
								<div>
									<span><img src="../../../assets/images/home/leader-index-icon.png"
											alt="">{{ timeActive | timeActiveFilter }}交易量</span>
									<span class="msg_num"
										:title="cumData.transactionCount + '宗'"><i>{{ cumData.transactionCount || 0 }}</i>宗</span>
								</div>
								<div>
									<span><img src="../../../assets/images/home/leader-index-icon.png"
											alt="">{{ timeActive | timeActiveFilter }}节约额</span>
									<span class="msg_num"
										:title="cumData.savingPrice + (cumData.savingPriceDigit == 1 ? '亿元' : '万元')"><i>{{ cumData.savingPrice || 0 }}</i>{{ cumData.savingPriceDigit == 1 ? '亿元' : '万元' }}</span>
								</div>
								<div>
									<span><img src="../../../assets/images/home/leader-index-icon.png"
											alt="">{{ timeActive | timeActiveFilter }}节约率</span>
									<span class="msg_num"
										:title="cumData.savingRate * 100 + '%'"><i>{{ (cumData.savingRate * 100).toFixed(2) }}</i>%</span>
								</div>
							</div>
							<div class="card_msg" v-show="!timer1Change" @mouseover="mouseOver(1)"
								@mouseleave="mouseLeave(1)">
								<div>
									<span><img src="../../../assets/images/home/leader-index-icon.png"
											alt="">{{ timeActive | timeActiveFilter }}交易量</span>
									<span class="msg_num"
										:title="cumData.transactionCount + '宗'"><i>{{ cumData.transactionCount || 0 }}</i>宗</span>
								</div>
								<div>
									<span><img src="../../../assets/images/home/leader-index-icon.png"
											alt="">{{ timeActive | timeActiveFilter }}增值额</span>
									<span class="msg_num"
										:title="cumData.estimatePrice + (cumData.estimatePriceDigit == 1 ? '亿元' : '万元')"><i>{{ cumData.estimatePrice || 0 }}</i>{{ cumData.estimatePriceDigit == 1 ? '亿元' : '万元' }}</span>
								</div>
								<div>
									<span><img src="../../../assets/images/home/leader-index-icon.png"
											alt="">{{ timeActive | timeActiveFilter }}增值率</span>
									<span class="msg_num"
										:title="cumData.addAmountRate * 100 + '%'"><i>{{ (cumData.addAmountRate * 100).toFixed(2) }}</i>%</span>
								</div>
							</div>
						</div>
						<div class="statistics_right" @mouseover="mouseOver(2)" @mouseleave="mouseLeave(2)">
							<div ref="line_pic" class="pic"></div>
							<!-- <div ref="bar_pic" class="pic" v-show="!timer2Change"></div> -->
						</div>
					</div>
				</el-card>
			</el-col>
			<el-col :span="6" :xl="6" :lg="7">
				<el-card class="calendar_matter common_matter">
					<div class="title">
						<p>日程管理</p>
					</div>
					<div class="calendar_con">
						<leaderCalendar></leaderCalendar>
						<div class="date_msg">
							<!-- <p>2020-04-08  12:00:00</p>
							<span>杭州</span>
							<span>下雨</span>
							<span>15℃</span>
							<span>优</span> -->
							<!-- <iframe width="auto" style="margin-top:0px" align="center" scrolling="no" height="25" frameborder="0" allowtransparency="true" src="https://i.tianqi.com?c=code&id=26&icon=1&site=18"></iframe> -->
							<span class="common">{{ weatherData.common }}</span>
							<span class="high">{{ weatherData.high }}</span>
							<span class="low">{{ weatherData.low }}</span>
						</div>
					</div>
				</el-card>
			</el-col>
		</el-row>
		<!-- 下 -->
		<el-row :gutter="10" class="bottom_matter">
			<el-col :span="18" :xl="18" :lg="17">
				<el-card class="project_matter common_matter">
					<div class="title">
						<div class="title_nav">
							<span :class="item.active == projectActive ? 'active' : null" v-for="(item, i) in activeList" :key="i"
								@click="navClick(item.active)">{{ item.name }}</span>
						</div>
						<div class="title_search">
							<div v-show="projectActive == 1 || projectActive == 2">
								<el-select class="title_select" v-model="formData.systemType" @change="changeSelect">
									<el-option v-for="(item, i) in projectTypeList" :key="i" :value="item.value"
										:label="item.text"></el-option>
								</el-select>
								<!-- <el-select class="title_select" v-model="formData.warnType">
									<el-option v-for="(item,i) in warnTypeList" :key="i" :value="item.value" :label="item.text"></el-option>
								</el-select> -->
								<el-input class="my_input" v-model="formData.searchKey" placeholder="请输入项目名称/编号">
									<i slot="suffix" class="el-input__icon el-icon-search" @click="changeSelect"></i>
								</el-input>
							</div>
						</div>
					</div>
					<div class="project_con" v-loading="projectLoading">
						<div v-if="paginationOpt.total == 0" class="no_message">
							<img src="../../../assets/images/home/empty.png" alt="">
							<p>暂无数据</p>
						</div>
						<template v-else>
							<div v-for="projectObj in projectData">
							
								<div class="projectItem"
									@click="goDetail()">
									<div class="project_header">
										<div style="display: flex;">
											<div class="project_code">
												<div class="trangle_right"></div>
												<div class="trangle_bottom"></div>
												{{ projectObj.bidSectionCode }}
											</div>
											<p class="project_text">{{ projectObj.bidSectionName }}</p>
										</div>
										<div>
											<el-button v-if="bidType == 'bidder' && filterType == '2'" size="mini"
												class="star_button" type="danger" @click="upDataAttentionStatusFn" plain>
												<i class="el-icon-star-on"></i>
												取消关注
											</el-button>
											<p class="todo_badge" @click.stop="goTodoList()"
												v-if="filterType != '2' && projectObj.todoNums">
												<icon-svg class="svg-icon" name="xiaoxi"
													style=" width: 16px; height: 16px; vertical-align: -3px;"></icon-svg>
												<span>{{ projectObj.todoNums }}</span>
											</p>
										</div>
									</div>
		
									<div class="time_box">{{ (projectObj.attributes &&
										projectObj.attributes.overTime) ? projectObj.attributes.overTime : formattTime(bidType ==
											'bidder' ? projectObj.noticePubtime : projectObj.createTime) }} </div>
								</div>
							</div>
						</template>
					</div>
				</el-card>
			</el-col>
			<el-col :span="6" :xl="6" :lg="7">
				<el-row :gutter="10" class="matter matter1">
					<el-col :span="24">
						<el-card class="app_matter common_matter">
							<div class="title">
								<p>快捷应用</p>
							</div>
							<div class="app_con scroll_hidden" @click="funDeleteFlag = false" @mouseover="mymouseIn"
								@mouseout="mymouseOut">
								<div class="app_add_del" @click="funDeleteFlag = false">
									<span @click.stop="funHandle(1)">添加</span>|
									<span @click.stop="funHandle(2)">删除</span>
								</div>
								<div class="app_main">
									<leaderApp class="app_par" @addfnclose="addfncloseHandle" v-for="item in fastFnData"
										:key="item.id" :data="item" :fileServerUrl="fileServerUrl"
										:funDeleteFlag="funDeleteFlag"></leaderApp>
								</div>
							</div>
						</el-card>
					</el-col>
				</el-row>
				<el-row :gutter="10" class="matter matter2">
					<el-col :span="24">
						<el-card class="enter_matter common_matter">
							<div class="title">
								<p>便捷入口</p>
								<el-dropdown class="my_dropdown" trigger="click" @command="quickChoose">
									<span class="el-dropdown-link">
										常用<i class="el-icon-arrow-down el-icon--right"></i>
									</span>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item :command="item.value" v-for="(item, i) in quickList"
											:key="i">{{ item.text }}</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>
							<div class="enter_con scroll_hidden" @click="isDelete = false" v-loading="enterLoading"
								@mouseover="mymouseIn" @mouseout="mymouseOut">
								<div class="enter_add_del" @click="enterDeleteFlag = false">
									<span @click.stop="addQuick">添加</span>|
									<span @click.stop="isDelete = true">删除</span>
								</div>
								<div class="enter_main">
									<draggable v-model="enterData" forceFallback="true" delay="100" animation="500"
										@end="endDragEnd">
										<div class="item clearfix" v-for="(item, i) in enterData" :key="i"
											:title="item.systemName" @click="enterLink(item)">
											<span>{{ item.systemName }}</span>
											<div class="go_icon" v-if="!isDelete"></div>
											<div class="delete" v-if="isDelete" @click.stop="deletedata(item)"></div>
										</div>
									</draggable>
								</div>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
		<schAdd :isVisiter="isVisiter" @close="closeSch" ref="schdialog"></schAdd>
		<addSystem @closedia="dialogCancel" :dialogVisibleVisiter="dialogVisible" ref="quickdialog"></addSystem>
		<addFun :addFundialogVisiter="addFundialog" @addfnclose="addfncloseHandle" ref="addfndialog"></addFun>
	</div>
</template>

<script>
import draggable from 'vuedraggable'
import echarts from 'echarts';
import { getNewTime, IsIE } from '@/utils/index';
// import leaderStep from './leader/leader-step';
import leaderApp from './leader/leader-app';
import leaderCalendar from './leader/leader-calendar';
import {
	apiworkBenchIndexProjectProgress, apijwtToJsgcProgress, apiwbschedulemanagementlist, apiwbconveniententranceconvenientEntranceList,
	apiwbconveniententrancedelete, apiwbconveniententrancedeleteCustomize, apijwtToSystem,
	apifilePath, apiwbconveniententrancesort
} from '@/server/common';
import {
	apiworkBenchIndexAuditListSort, apiworkBenchIndexStatisticsIndex, apiworkBenchIndexIndexlineChart,
	apiworkBenchIndexIndexSummaryGraph, apiworkBenchIndexIndexroleStatistics, apiprojectAuditCount,
	apiworkBenchIndexweather
} from '@/server/home-leader';
import { mapState } from 'vuex';
import { linePicOption, barPicOption, quickList, leaderTaskNav, projectTypeList, warnTypeList } from '@/utils/busyness';
import schAdd from './common/sch_add';
import addSystem from './common/add-system';
import { APIwbconveniententranceconvenientList } from '@/server/home-center';
import addFun from './center/add-fun.vue';
export default {
	name: 'LeaderPage',
	components: {
		leaderCalendar,
		// leaderStep,
		leaderApp,
		schAdd,
		addSystem,
		addFun,
		draggable
	},
	data() {
		return {
			timeInterval: 8000,//定时器间隔
			projectActive: 1,//项目跟踪 项目预警 项目投诉
			timeActive: 1,//本月 本年 全部
			timer1Change: false,
			timer2Change: false,
			timeList: [
				{ name: '本月', active: 1 },
				{ name: '本年', active: 2 },
				{ name: '全部', active: 0 }
			],
			activeList: [
				{ name: '项目跟踪', active: 1 },
				// {name:'项目预警',active:2},
				// {name:'项目投诉',active:3}
			],
			taskNav: leaderTaskNav,//项目待办任务nav
			taskNavChoose: 1,
			taskLoading: false,
			taskList: [],
			schLoading: false,
			schList: [],
			schOption: {
				pageIndex: 1,
				pageSize: 6,
				isMore: true
			},
			timer1: null,//左边定时器
			timer2: null,//图表定时器
			cumData: {
				transactionAmount: 0,//累计成交额
				transactionAmountDigit: 0,//累计成交额展示亿元还是万元
				transactionCount: 0,//交易量
				estimatePrice: 0,//增值额
				estimatePriceDigit: 0,//增值额展示亿元还是万元
				addAmountRate: 0,//增值率
				savingPrice: 0,//节约额
				savingPriceDigit: 0,//节约额展示亿元还是万元
				savingRate: 0//节约率
			},//交易统计交易量
			businessMoneyData: {},//交易额图表交易额数据
			businessNumberData: {},//交易额图表交易量数据
			projectTimeLoading: false,
			projectTimeData: [],//项目待办时长排名
			projectData: [],//项目跟踪数据
			projectLoading: false,
			projectTypeList: projectTypeList,
			warnTypeList: warnTypeList,
			paginationOpt: {
				pageIndex: 1,
				pageSize: 6,
				total: 0,
				pageSizes: [6, 12, 18]
			},
			linePic: null,
			barPic: null,
			addFundialog: false,
			fastFnData: [],//快捷应用数据
			funDeleteFlag: false,
			isVisiter: false,
			quickList: quickList,//便捷入口下拉数据
			quickChooseValue: '',//便捷入口下拉选择值
			dialogVisible: false,
			enterLoading: false,//便捷入口等待框
			enterData: [],
			enterItem: {},//删除的项目数据
			isDelete: false,
			contextMenuData: {
				menuName: 'demo',
				//菜单显示的位置
				axis: {
					x: null,
					y: null
				},
				menulists: [{
					fnHandler: 'deletedata',
					icoName: 'el-icon-delete',
					btnName: '删除'
				}]
			},
			fileServerUrl: '',
			formData: {
				systemType: 'GC',
				warnType: '',
				searchKey: ''
			},
			weatherData: {
				common: '',
				high: '',
				low: ''
			}
		}
	},
	computed: {
		...mapState([
			'user'
		]),
		// 计算历时时间
		durationTime() {
			return (createDate, projectEndTime) => {
				let timestamp = Date.parse(new Date(getNewTime()));
				let createDataTamp = "";
				if (IsIE()) {
					createDataTamp = Date.parse(createDate.replace('-', '/'));
				} else {
					createDataTamp = Date.parse(createDate);
				}
				if (projectEndTime) {
					let projectEndTamp = "";
					if (IsIE()) {
						projectEndTamp = Date.parse(projectEndTime.replace('-', '/'));
					} else {
						projectEndTamp = Date.parse(projectEndTime);
					}
					return Math.ceil((projectEndTamp - createDataTamp) / 1000 / 60 / 60 / 24);
				} else {
					return Math.ceil((timestamp - createDataTamp) / 1000 / 60 / 60 / 24);
				}
			}
		}
	},
	mounted() {
		this.init();
		clearInterval(this.timer1);
		clearInterval(this.timer2);
		// this.timer2Fn();
		this.timer1 = setInterval(this.timer1Fn, this.timeInterval);
		this.timer2 = setInterval(this.timer2Fn, this.timeInterval);
		this.linePic = echarts.init(this.$refs.line_pic);
		this.barPic = echarts.init(this.$refs.line_pic);
		window.addEventListener('resize', () => {
			this.linePic.resize()
		});
		window.addEventListener('resize', () => {
			this.barPic.resize()
		});
	},
	destroyed() {
		clearInterval(this.timer1);
		clearInterval(this.timer2);
	},
	methods: {
		init() {
			this.apifilePath();// 获取文件服务器地址
			this.apiworkBenchIndexStatisticsIndex();// 获取交易统计交易量数据
			this.apiworkBenchIndexIndexSummaryGraph();// 交易统计获取交易额统计图数据-交易量
			this.apiworkBenchIndexIndexlineChart();// 交易统计获取交易额统计图数据-交易额
			this.getWeather();//获取天气
			this.apiworkBenchIndexIndexroleStatistics();// 项目待办任务统计按角色统计
			this.projectTimeInit();// 获取项目待办时长排名数据
			this.apiwbschedulemanagementlist();// 获取日程管理列表
			this.projectInit();// 获取项目跟踪数据
			this.APIwbconveniententranceconvenientList();// 获取快捷应用数据
			this.apiwbconveniententranceconvenientEntranceList();// 获取便捷入口列表数据
		},
		// 获取天气
		getWeather() {
			apiworkBenchIndexweather().then(({ data }) => {
				this.weatherData.common = `${data.data.city} ${data.data.forecast[0].type}`;
				this.weatherData.high = `${data.data.forecast[0].high}`;
				this.weatherData.low = `${data.data.forecast[0].low}`;
			})
		},
		// 获取文件服务器地址
		apifilePath() {
			apifilePath().then((res) => {
				const { data } = res;
				this.fileServerUrl = data;
			})
		},
		// 交易统计获取交易量数据
		apiworkBenchIndexStatisticsIndex() {
			apiworkBenchIndexStatisticsIndex(this.timeActive).then((res) => {
				const { data } = res;
				if (data.code == '1') {
					this.cumData = data.data;
				} else {
					this.cumData = {};
				}
			})
		},
		// 交易统计获取交易额统计图数据-交易量
		apiworkBenchIndexIndexSummaryGraph() {
			apiworkBenchIndexIndexSummaryGraph().then((res) => {
				const { data } = res;
				if (data.code == '1') {
					this.businessNumberData = data.data;
					this.drawBarPic();
				}
			})
		},
		// 交易统计获取交易额统计图数据-交易额
		apiworkBenchIndexIndexlineChart() {
			apiworkBenchIndexIndexlineChart().then((res) => {
				const { data } = res;
				if (data.code == '1') {
					this.businessMoneyData = data.data;
					this.drawLinePic();
				}
			})
		},
		timer1Fn() {
			this.timer1Change = !this.timer1Change;
			// this.apiworkBenchIndexStatisticsIndex();
		},
		timer2Fn() {
			this.timer2Change = !this.timer2Change;
			// this.timer2Change&&this.apiworkBenchIndexIndexSummaryGraph();
			// !this.timer2Change&&this.apiworkBenchIndexIndexlineChart();
			this.timer2Change && this.drawBarPic();
			!this.timer2Change && this.drawLinePic();
		},
		// 统计移入事件
		mouseOver(num) {
			num == 1 && clearInterval(this.timer1);
			num == 2 && clearInterval(this.timer2);
		},
		// 统计移出事件
		mouseLeave(num) {
			if (num == 1) {
				this.timer1 = setInterval(this.timer1Fn, this.timeInterval);
			}
			if (num == 2) {
				this.timer2 = setInterval(this.timer2Fn, this.timeInterval);
			}
		},
		// 折线图
		drawLinePic() {
			let option = linePicOption(this.businessMoneyData);
			this.linePic.setOption(option, true);
			this.linePic.off('legendselectchanged');
			// this.linePic.on('legendselectchanged',function(obj){
			// 	console.log(111,obj)
			// })
		},
		// 柱状图
		drawBarPic() {
			let option = barPicOption(this.businessNumberData);
			// this.barPic.clear();
			this.barPic.setOption(option, true);
			this.barPic.off('legendselectchanged');
			// this.barPic.on('legendselectchanged',function(obj){
			// 	console.log(222,obj)
			// })
		},
		// 本月 本年 全部点击事件
		timeClick(i) {
			this.timeActive = i;
			clearInterval(this.timer1);
			this.apiworkBenchIndexStatisticsIndex();
			this.timer1 = setInterval(this.timer1Fn, this.timeInterval);
		},
		taskChange(value) {
			this.taskNavChoose = value;
			this.taskNavChoose == 1 && this.apiworkBenchIndexIndexroleStatistics();
			this.taskNavChoose == 2 && this.apiprojectAuditCount();
		},
		// 项目待办任务统计按角色统计
		apiworkBenchIndexIndexroleStatistics() {
			this.taskLoading = true;
			apiworkBenchIndexIndexroleStatistics().then((res) => {
				const { data } = res;
				if (data.code == '1') {
					this.taskList = data.data || [];
				}
			}).finally(() => { this.taskLoading = false; })
		},
		// 项目待办任务统计按项目类型统计
		apiprojectAuditCount() {
			this.taskLoading = true;
			apiprojectAuditCount().then((res) => {
				const { data } = res;
				if (data.code == '1') {
					this.taskList = data.data || [];
				}
			}).finally(() => { this.taskLoading = false; })
		},
		// 项目待办时长排名获取数据
		projectTimeInit() {
			this.projectTimeLoading = true;
			apiworkBenchIndexAuditListSort({
				page: 1,
				rows: 5
			}).then((res) => {
				const { data } = res;
				if (data.code == '1') {
					this.projectTimeData = data.data || [];
				}
			}).finally(() => { this.projectTimeLoading = false; })
		},
		// 获取日程管理列表
		apiwbschedulemanagementlist() {
			this.schLoading = true;
			apiwbschedulemanagementlist({
				page: this.schOption.pageIndex,
				rows: this.schOption.pageSize,
				filter: {
					completeStatus: 0
				}
			}).then((res) => {
				const { data } = res;
				if (data.rows.length > 0) {
					this.schList = [...this.schList, ...data.rows];
				}
				if (Math.ceil(data.total / 6) == this.schOption.pageIndex) {
					this.schOption.isMore = false;
				}
			}).finally(() => { this.schLoading = false; })
		},
		// 日程管理某一行点击事件
		rcglRowClick(item) {
			this.isVisiter = true;
			this.$refs.schdialog.apiwbschedulemanagementget(item.id);
		},
		// 日程管理添加按钮
		schAdd() {
			this.isVisiter = true;
		},
		// 日程管理弹框关闭事件
		closeSch(data) {
			this.isVisiter = false;
			if (data) {
				this.schList = [];
				this.schOption.isMore = true;
				this.schOption.pageIndex = 1;
				this.apiwbschedulemanagementlist();
			}
		},
		// 日程管理滚轮加载更多
		schScrollMoreData(e) {
			if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 60 && !this.schLoading && this.schOption.isMore) {
				this.schOption.pageIndex += 1;
				this.apiwbschedulemanagementlist();
			}
		},
		schMoveHandle() {
			this.schOption.isMore = true;
			this.schList = [];
			this.schOption.pageIndex = 1;
			this.apiwbschedulemanagementlist();
		},
		// 项目跟踪获取数据
		projectInit() {
			this.projectLoading = true;
			let listType = this.user.role == 'ROLE_JYZX_USER' ? 2 : this.user.role == 'ROLE_JYZXSH_USER' ? 1 : '';
			apiworkBenchIndexProjectProgress({
				page: this.paginationOpt.pageIndex,
				rows: this.paginationOpt.pageSize,
				filter: {
					listType: listType,
					// systemType:this.formData.systemType
				},
				searchKey: this.formData.searchKey,
				type: this.formData.systemType
			}).then((res) => {
				const { data } = res;
				this.projectData = data.rows || [];
				this.paginationOpt.total = data.total || 0;
			}).finally(() => { this.projectLoading = false; })
		},
		changeSelect() {
			this.paginationOpt.pageIndex = 1;
			this.projectInit();
		},
		// 项目跟踪 项目预警 项目投诉点击事件
		navClick(i) {
			this.projectActive = i;
			if (this.projectActive == 1) {
				this.paginationOpt = {
					pageIndex: 1,
					pageSize: 6,
					total: 0,
					pageSizes: [6, 12, 18]
				}
				this.projectInit();
			} else if (this.projectActive == 2) {
				this.paginationOpt = {
					pageIndex: 1,
					pageSize: 10,
					total: 0
				}
			} else {
				this.paginationOpt = {
					pageIndex: 1,
					pageSize: 10,
					total: 0
				}
			}
		},
		// 每页长度改变事件
		sizeChangeHandle(value) {
			this.paginationOpt.pageSize = value;
			this.paginationOpt.pageIndex = 1;
			this.projectActive == 1 && this.projectInit();
		},
		// 页面修改事件
		pageChangeHandle(value) {
			this.paginationOpt.pageIndex = value;
			this.projectActive == 1 && this.projectInit();
		},
		/**
		 * 查看页面跳转
		 * @param {Number} type GC为工程建设 CG政府采购
		 * @param {Object} option
		 * @returns
		 */
		routerTo(type, option) {
			this.apijwtToJsgcProgress({ field2: type, bidId: option.bidId, projectstate: option.buyprojectState, title: '项目流程' });
		},
		// 更多请求地址
		apijwtToJsgcProgress(temp) {
			apijwtToJsgcProgress(temp).then((res) => {
				const { data } = res;
				if (data.code == '1') {
					addPanel('跟踪详情', data.data)
				} else {
					this.$alert(data.msg);
				}
			})
		},
		// 便捷入口获取列表
		apiwbconveniententranceconvenientEntranceList() {
			// this.enterLoading=true;
			apiwbconveniententranceconvenientEntranceList({
				page: 1,
				rows: 100,
				filter: {
					systemType: this.quickChooseValue
				}
			}).then((res) => {
				const { data } = res;
				this.enterData = data.rows;
			}).finally(() => { this.enterLoading = false; })
		},
		// 添加常用系统按钮点击
		addQuick() {
			this.dialogVisible = true;
			this.$refs.quickdialog.apiwbsystemconfiggetSystemConfigList(this.quickChooseValue);
		},
		// 便捷入口选择
		quickChoose(value) {
			this.quickChooseValue = value;
			this.apiwbconveniententranceconvenientEntranceList();
		},
		// 便捷入口弹框关闭
		dialogCancel() {
			this.dialogVisible = false;
			this.apiwbconveniententranceconvenientEntranceList();
		},
		// 鼠标右击事件
		showMenu(item) {
			if (event.preventDefault) {
				event.preventDefault();
			} else {
				window.event.returnValue = false;
			}
			this.enterItem = item;
			var x = event.clientX;
			var y = event.clientY;
			// Get the current location
			this.contextMenuData.axis = {
				x, y
			}
			return false;
		},
		// 鼠标右击删除功能
		deletedata(arg) {
			this.$confirm('是否删除本条记录？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				arg.customizeStatus == 0 && apiwbconveniententrancedelete({ id: arg.id }).then((res) => {
					const { data } = res;
					if (data.code == '1') {
						this.apiwbconveniententranceconvenientEntranceList();
					} else {
						this.$message.error(data.msg)
					}
				})
				arg.customizeStatus == 1 && apiwbconveniententrancedeleteCustomize({ id: arg.id, systemConfigId: arg.systemConfigId }).then((res) => {
					const { data } = res;
					if (data.code == '1') {
						this.apiwbconveniententranceconvenientEntranceList();
					} else {
						this.$message.error(data.msg)
					}
				})
			}).catch(() => { })
		},
		// 便捷入口跳转到对应地址
		enterLink(item) {
			if (item.customizeStatus == 0) {
				apijwtToSystem(item.systemConfigId).then((res) => {
					const { data } = res;
					if (data.code == '1') {
						window.open(data.data);
					} else {
						this.$alert(data.msg);
					}
				})
			} else if (item.customizeStatus == 1) {
				let reg = /http/;
				if (reg.test(item.systemUrl)) {
					window.open(item.systemUrl);
				} else {
					window.open(`//${item.systemUrl}`);
				}
			}
		},
		// 快捷应用
		APIwbconveniententranceconvenientList() {
			APIwbconveniententranceconvenientList({
				page: 1,
				rows: 100,
			}).then(({ data }) => {
				this.fastFnData = data.rows || [];
			})
		},
		funHandle(type) {
			if (type == 1) {
				this.addFundialog = true;
				this.$refs.addfndialog.init();
			} else if (type == 2) {
				this.funDeleteFlag = !this.funDeleteFlag;
			}
		},
		addfncloseHandle() {
			this.addFundialog = false;
			this.APIwbconveniententranceconvenientList();
		},
		endDragEnd() {
			apiwbconveniententrancesort(this.enterData).then(({ data }) => {
				if (data.code == '1') {
					this.apiwbconveniententranceconvenientEntranceList();
				}
			})
		}
	}
}
</script>

<style lang="less" scoped>
@import "./home-leader.less";

.leader {
	.enter_matter {
		.item {
			.go_icon {
				background: url('../../../assets/images/home/goto_default.png') no-repeat;
			}

			&:hover .go_icon {
				background: url('../../../assets/images/home/goto_hover.png') no-repeat;
			}

			.delete {
				width: 42px;
				height: 42px;
				position: absolute;
				right: 0;
				top: -1px;
				border-radius: 0px 3px 3px 0px;
				background: rgba(255, 0, 0, 0.4) url('../../../assets/images/home/delete_icon.png') no-repeat;
				background-position: center center;
			}
		}
	}
}



.el-select {
	display: inline-block;
	position: relative;
}

.projectItem {
        min-height: 90px;
        border-bottom: 1px dashed #ccc;
        padding: 10px;
        cursor: pointer;
        position: relative;



          .yuanQuan {
              display: inline-block;
              width: 10px;
              height: 10px;
              border-radius: 5px;
              margin-left: 1px;
          }
          .yuanQuan.isYellow{
              border: 1px solid #ff9900;
          }
          .yuanQuan.isGray{
              border: 1px solid rgba(0,0,0,0.35);
          }
          .yuanQuan.isBlack{
              border: 1px solid rgba(0, 0, 0, 0.85);
          }

        .project_header {
          display: flex;
          justify-content: space-between;

            .el-button.star_button:hover,.el-button.star_button:focus{
                color: #FF9900;
                background: #FFF9E6;
                border-color: #FF9900;
            }

            .star_button.el-button--danger{
                color: #FF9900;
                background: #FFF9E6;
                border-color: #FF9900;
            }

          .project_code {
            position: relative;
            color: rgba(0,0,0,0.85);
            width: auto;
            height: 24px;
            padding: 0px 4px 0px 4px;
            //left:-20px;
            left:-16px;
            text-align: center;
            line-height: 24px;
            background-color: #EFF3F6;
          }
          .trangle_right {
            border-color: transparent transparent transparent #EFF3F6;
            border-style: solid;
            border-width: 12px 0 12px 12px;
            height: 0;
            width: 0;
            position: absolute;
            right: -12px;
            top: 0;
          }
          .trangle_bottom {
              border-color: transparent transparent transparent #E3E7EB;
              border-style: solid;
             // border-width: 4px 0 0px 8px;
             border-width: 2px 0 0px 4px;
              -webkit-transform: rotate(-45deg);
              transform: rotate(-180deg);
              position: absolute;
             // bottom: -4px;
             bottom: -2px;
              left: 1px;
          }
          .project_text{
            //margin-left: 30px;
            margin-left: -4px;
            line-height: 24px;
            text-align: left;
            font-weight: 700;
            color:#000000;
          }
          .project_link {
            width:50%;
            text-align: right;
            color: #1890ff;
            cursor: pointer;
          }

            .todo_badge{
                background: #FEEBEB;
                color: #EF6666;
                padding: 0 12px;
                height: 20px;
                color: red;
                cursor:pointer;
                display: inline-block;
                //border-radius: 10px;
                 border-radius: 8px 0px 8px 8px;
                  span{
                      margin-left: 4px;
                      display: inline-block;
                      height: 20px;
                      line-height: 20px;
                      font-weight: 400;
                      font-size: 14px;
                      position: relative;
                      //top: -2px;
                  }

                &:hover{
                    background: linear-gradient(46deg, #FF3838 0%, #FF6593 100%);
                    color:white;
                }
            }


        }
        .stepWrapper {
          width:calc(100% - 150px);
          padding: 0 10px;
          .nodeCircleBlue{
            display: inline-block;
            width:16px;
            height:16px;
            border-radius: 50%;
            border:2px solid #1890FF;
            margin-right:4px;
            span{
              display: inline-block;
              border:3px solid #1890FF;
              width: 3px;
              height: 3px;
              background: #1890FF;
              border-radius:50% ;
              position: relative;
              top: -3px;
              left: 3px;
            }
          }
          .nodeCircleGrey{
            display: inline-block;
            width:10px;
            height:10px;
            border-radius: 50%;
            background: #FFFFFF;
            opacity: 1;
            border: 2px solid rgba(0,0,0,0.45);
          }
          // 组件样式修改
          /deep/ .el-step__line {
            margin-left: 70px;
            margin-right: 12px !important;
          }
          /deep/ .el-step__icon.is-text {
            border: none;
              width: auto;
             padding-right: 12px;
          }
          /deep/ .el-step__head.is-finish {
            color: #1890ff;
            border-color: #1890ff;
          }
        }
          .time_box {
              position: absolute;
              right:8px;
              bottom: 20px;
              color:rgba(0,0,0,0.45)
          }
      }
      .projectItem:last-child{
        border-bottom: none;
      }
</style>
